export class ChartOptionUtils {
  public static isOverTimeAggregator(agg: string): boolean {
    return ['AVG', 'SUM', 'time', 'percentage_time'].indexOf(agg) >= 0;
  }
}
